
import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({})
export default class DlgConfirmDelete extends Vue {
  @Prop({type: String, default: ''}) private title!: string;
  @Prop({type: String, default: ''}) private icon!: string;

  private dialog: boolean = false;

  private agree() {
    this.$emit('true');
    this.dialog = false;
  }

  private disagree() {
    this.$emit('false');
    this.dialog = false;
  }
}
